const productInfo = {
    "totalliftincm": {
        "name": "Total Lift in (cm)",
        "group": "DIMENSIONS"
    },
    "heightincm": {
        "name": "Height in (cm)",
        "group": "DIMENSIONS"
    },
    "lengthincm": {
        "name": "Length in (cm)",
        "group": "DIMENSIONS"
    },
    "platformsizeftm": {
        "name": "Platform Size Ft (M)",
        "group": "DIMENSIONS"
    },
    "hydraulicextensionincmhydrauliclift": {
        "name": "Hydraulic Extension in (cm)",
        "group": "DIMENSIONS"
    },
    "weightlbkg": {
        "name": "Weight LB (KG)",
        "group": "DIMENSIONS"
    },
    "extendedlengthincm": {
        "name": "Extended Length in (cm)",
        "group": "DIMENSIONS"
    },
    "closedheightincm": {
        "name": "Closed Height in (cm)",
        "group": "DIMENSIONS"
    },
    "tirediameterrangeincm": {
        "name": "Tire Diameter Range in (cm)",
        "group": "DIMENSIONS"
    },
    "raisedheightclearancefm": {
        "name": "Raised Height Clearance F (M)",
        "group": "DIMENSIONS"
    },
    "wheelsize": {
        "name": "Wheel Size",
        "group": "DIMENSIONS"
    },
    "mechanicalextensionincmextensionscrew": {
        "name": "Mechanical Extension in (cm) (Extension Screw)",
        "group": "DIMENSIONS"
    },
    "raisedplatformheightftm": {
        "name": "Raised Platform Height Ft (M)",
        "group": "DIMENSIONS"
    },
    "closedplatformheightincm": {
        "name": "Closed Platform Height in (cm)",
        "group": "DIMENSIONS"
    },
    "tiresincm": {
        "name": "Tires in (cm)",
        "group": "DIMENSIONS"
    },
    "boomliftrangeincm": {
        "name": "Boom Lift Range in (cm)",
        "group": "DIMENSIONS"
    },
    "extendedincm": {
        "name": "Extended in (cm)",
        "group": "DIMENSIONS"
    },
    "tankcapacitygall": {
        "name": "Tank Capacity Gal (L)",
        "group": "DIMENSIONS"
    },
    "wastereservoircapacitygal": {
        "name": "Waste Reservoir Capacity (Gal)",
        "group": "DIMENSIONS"
    },
    "platformheightftm": {
        "name": "Platform Height Ft (M)",
        "group": "DIMENSIONS"
    },
    "heightcollapsedincm": {
        "name": "Height (Collapsed) in (cm)",
        "group": "DIMENSIONS"
    },
    "extendedheightincm": {
        "name": "Extended Height in (cm)",
        "group": "DIMENSIONS"
    },
    "wheelsizeincm": {
        "name": "Wheel Size in (cm)",
        "group": "DIMENSIONS"
    },
    "rangeincm": {
        "name": "Range in (cm)",
        "group": "DIMENSIONS"
    },
    "alarm": {
        "name": "Alarm",
        "group": "DIMENSIONS"
    },
    "closedincm": {
        "name": "Closed in (cm)",
        "group": "DIMENSIONS"
    },
    "overalllengthftm": {
        "name": "Overall Length Ft (M)",
        "group": "DIMENSIONS"
    },
    "hoselengthincm": {
        "name": "Hose Length in (cm)",
        "group": "DIMENSIONS"
    },
    "basedimensionscollapsedftm": {
        "name": "Base Dimensions (Collapsed) Ft (M)",
        "group": "DIMENSIONS"
    },
    "rimdiameterincm": {
        "name": "Rim Diameter in (cm)",
        "group": "DIMENSIONS"
    },
    "widthincm": {
        "name": "Width in (cm)",
        "group": "DIMENSIONS"
    },
    "baseradius": {
        "name": "Base Radius",
        "group": "DIMENSIONS"
    },
    "widthcollapsedcm": {
        "name": "Width (Collapsed) in (cm)",
        "group": "DIMENSIONS"
    },
    "rimsizerangecm": {
        "name": "Rim Size Range in (cm)",
        "group": "DIMENSIONS"
    },
    "inputvoltagevolts": {
        "name": "Input Voltage (Volts)",
        "group": "ELECTRICAL"
    },
    "outputcable": {
        "name": "Output Cable",
        "group": "ELECTRICAL"
    },
    "voltage": {
        "name": "Voltage",
        "group": "ELECTRICAL"
    },
    "inputcableftm": {
        "name": "Input Cable Ft (M)",
        "group": "ELECTRICAL"
    },
    "frequencyhz": {
        "name": "Frequency Hz",
        "group": "ELECTRICAL"
    },
    "maximumdrawamp": {
        "name": "Maximum Draw Amp",
        "group": "ELECTRICAL"
    },
    "electricalvhzph": {
        "name": "Electrical V/Hz/Ph",
        "group": "ELECTRICAL"
    },
    "inputphase": {
        "name": "Input Phase",
        "group": "ELECTRICAL"
    },
    "peakamp": {
        "name": "Peak Amp",
        "group": "ELECTRICAL"
    },
    "continuousamp": {
        "name": "Continuous Amp",
        "group": "ELECTRICAL"
    },
    "motorhpkw": {
        "name": "Motor HP (KW)",
        "group": "ENGINE/MOTOR SPECS"
    },
    "enginemanufacturermodel": {
        "name": "Engine Manufacturer/Model",
        "group": "ENGINE/MOTOR SPECS"
    },
    "engine": {
        "name": "Engine",
        "group": "ENGINE/MOTOR SPECS"
    },
    "strokedisplacementinstrokeccstroke": {
        "name": "Stroke Displacement In/Stroke (CC/Stroke)",
        "group": "ENGINE/MOTOR SPECS"
    },
    "filtration": {
        "name": "Filtration",
        "group": "FILTRATION"
    },
    "hydraulicfluid": {
        "name": "Hydraulic Fluid",
        "group": "FLUIDS"
    },
    "reservoircapacitygal": {
        "name": "Reservoir Capacity (Gal)",
        "group": "FLUIDS"
    },
    "fluid": {
        "name": "Fluid",
        "group": "FLUIDS"
    },
    "fluidcapacityozl": {
        "name": "Fluid Capacity Oz (L)",
        "group": "FLUIDS"
    },
    "fuel": {
        "name": "Fuel",
        "group": "FUEL"
    },
    "gas": {
        "name": "Gas",
        "group": "FUEL"
    },
    "returnhosesystem2size": {
        "name": "Return Hose System 2 Size",
        "group": "HOSES"
    },
    "pressurehosesize": {
        "name": "Pressure Hose Size",
        "group": "HOSES"
    },
    "returnhosesize": {
        "name": "Return Hose Size",
        "group": "HOSES"
    },
    "returnhosesystem1size": {
        "name": "Return Hose System 1 Size",
        "group": "HOSES"
    },
    "pressurehosesystem1size": {
        "name": "Pressure Hose System 1 Size",
        "group": "HOSES"
    },
    "pressurehosesystem2size": {
        "name": "Pressure Hose System 2 Size",
        "group": "HOSES"
    },
    "capacitygall": {
        "name": "Capacity Gal (L)",
        "group": "PERFORMANCE"
    },
    "capacitytons": {
        "name": "Capacity Tons",
        "group": "PERFORMANCE"
    },
    "reservoirfill": {
        "name": "Reservoir Fill",
        "group": "PERFORMANCE"
    },
    "pressurerangepsibar": {
        "name": "Pressure Range PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "maximumtowingspeedmph": {
        "name": "Maximum Towing Speed (MPH)",
        "group": "PERFORMANCE"
    },
    "aircraftweightcapacitylbkg": {
        "name": "Aircraft Weight Capacity LB (KG)",
        "group": "PERFORMANCE"
    },
    "boosteroperatingpressurepsi": {
        "name": "Booster Operating Pressure (PSI)",
        "group": "PERFORMANCE"
    },
    "ratedworkloadlbkg": {
        "name": "Rated Work Load LB (KG)",
        "group": "PERFORMANCE"
    },
    "pumpflowsystem2gpmlpm": {
        "name": "Pump Flow System 2 GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "flowrangescfm": {
        "name": "Flow Range SCFM",
        "group": "PERFORMANCE"
    },
    "bottlecapacity": {
        "name": "Bottle Capacity",
        "group": "PERFORMANCE"
    },
    "workingrangeftm": {
        "name": "Working Range Ft (M)",
        "group": "PERFORMANCE"
    },
    "flowatratedpressuregpmlpm": {
        "name": "Flow at Rated Pressure GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "incrementspsibar": {
        "name": "Increments PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "filltankgall": {
        "name": "Fill Tank Gal (L)",
        "group": "PERFORMANCE"
    },
    "pumppsibar": {
        "name": "Pump PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "maximumaircraftgrossweightlbsmetrictons": {
        "name": "Maximum Aircraft Gross Weight Lbs (Metric Tons)",
        "group": "PERFORMANCE"
    },
    "pressuregaugepsibar": {
        "name": "Pressure Gauge PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "pumpflowsystem1gpmlpm": {
        "name": "Pump Flow System 1 GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "highoperatingpressurepsi": {
        "name": "High Operating Pressure (PSI)",
        "group": "PERFORMANCE"
    },
    "pressureandreturndualsystem": {
        "name": "Pressure and Return Dual System",
        "group": "PERFORMANCE"
    },
    "dumptankgall": {
        "name": "Dump Tank Gal (L)",
        "group": "PERFORMANCE"
    },
    "pumpflow50hzgpmlpm": {
        "name": "Pump Flow (50 HZ) GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "pumpflow60hzgpmlpm": {
        "name": "Pump Flow (60 HZ) GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "pressurereliefvalvesetatpsibar": {
        "name": "Pressure Relief Valve Set at PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "maxaircraftweightlbkg": {
        "name": "Max Aircraft Weight LB (KG)",
        "group": "PERFORMANCE"
    },
    "lowoperatingpressurepsi": {
        "name": "Low Operating Pressure (PSI)",
        "group": "PERFORMANCE"
    },
    "flowmaxgpmlpm": {
        "name": "Flow Max GPM (LPM)",
        "group": "PERFORMANCE"
    },
    "capacitylbkg": {
        "name": "Capacity LB (KG)",
        "group": "PERFORMANCE"
    },
    "maxpressurepsibar": {
        "name": "Max Pressure PSI (Bar)",
        "group": "PERFORMANCE"
    },
    "rateofclimbindicatorftmincmsec": {
        "name": "Rate of Climb Indicator FT/MIN (CM/SEC)",
        "group": "PERFORMANCE"
    },
    "pressureandreturnsinglesystem": {
        "name": "Pressure and Return Single System",
        "group": "PERFORMANCE"
    },
    "pumptype": {
        "name": "Pump Type",
        "group": "PUMP"
    },
    "fillpump": {
        "name": "Fill Pump",
        "group": "PUMP"
    },
    "requiredgroundtesttool": {
        "name": "Required Ground Test Tool",
        "group": "REQUIREMENTS"
    },
    "requiredhpuseries": {
        "name": "Required HPU Series",
        "group": "REQUIREMENTS"
    },
    "usewithcouplingkit": {
        "name": "Use with Coupling Kit",
        "group": "REQUIREMENTS"
    },
    "speedfullloadmphkph": {
        "name": "Speed Full Load MPH (KPH)",
        "group": "TRAVEL"
    },
    "speedemptymphkph": {
        "name": "Speed Empty MPH (KPH)",
        "group": "TRAVEL"
    },
    "shock": {
        "name": "Shock",
        "group": "TYPE/OTHER"
    },
    "operation": {
        "name": "Operation",
        "group": "TYPE/OTHER"
    },
    "headstyle": {
        "name": "Head Style",
        "group": "TYPE/OTHER"
    },
    "totalizer": {
        "name": "Totalizer",
        "group": "TYPE/OTHER"
    },
    "driverbits": {
        "name": "Driver Bits",
        "group": "TYPE/OTHER"
    },
    "heater": {
        "name": "Heater",
        "group": "TYPE/OTHER"
    },
    "singleormultistage": {
        "name": "Single (S) or Multi (M) Stage",
        "group": "TYPE/OTHER"
    },
    "portable": {
        "name": "Portable",
        "group": "TYPE/OTHER"
    },
    "booster": {
        "name": "Booster",
        "group": "TYPE/OTHER"
    },
    "referencerat": {
        "name": "Reference (RAT)",
        "group": "TYPE/OTHER"
    },
    "handpumpairpump": {
        "name": "Hand Pump/Air Pump",
        "group": "TYPE/OTHER"
    },
    "shearprotection": {
        "name": "Shear Protection",
        "group": "TYPE/OTHER"
    },
    "jackapplication": {
        "name": "Jack Application",
        "group": "TYPE/OTHER"
    },
    "type": {
        "name": "Type",
        "group": "TYPE/OTHER"
    },
    "system": {
        "name": "System",
        "group": "TYPE/OTHER"
    },
    "heads": {
        "name": "Heads",
        "group": "TYPE/OTHER"
    },
    "tiltable": {
        "name": "Tiltable",
        "group": "TYPE/OTHER"
    },
    "color": {
        "name": "Color",
        "group": "TYPE/OTHER"
    },
    "manufacturerpropellerblade": {
        "name": "Manufacturer/Propeller/Blade",
        "group": "USAGE"
    },
    "usage": {
        "name": "Usage",
        "group": "USAGE"
    },
    "atachapter": {
        "name": "ATA Chapter",
        "group": ""
    },
    "aircraftmanufacturers": {
        "name": "Aircraft Manufacturers",
        "group": ""
    },
    "standardfeatures": {
        "name": "Standard Features",
        "group": ""
    },
    "aircraftmodels": {
        "name": "Aircraft Models",
        "group": ""
    }
  }

  //access the productInfo object
  //loop through the object, find specifics from product page, replace them with name
  //move groups together with append

Object.entries(productInfo).forEach(([key, details]) => {
    setTimeout(() => {
        const productSpecName = document.querySelectorAll('.product-info-content .product-metafield > strong')
        productSpecName.forEach(product => {
            if (product.textContent == `${key}:`) {
                product.textContent = `${details.name}:`
            }
        })
    }, 10);
});
setTimeout(() => {
    const productSpecDetail = document.querySelectorAll('.product-info-content .product-metafield p')
    productSpecDetail.forEach(element => {
        element.textContent = element.textContent.replaceAll(',', ', ')
    });
},10)

const productInfoHeaderContainer = document.querySelector('.product-info-container-header');
const productInfoContainer = document.querySelector('.product-info-container');
const lowerHeaderLinks = document.querySelectorAll('.lower-header .product-info-title-header');

lowerHeaderLinks.forEach(link => {
  link.addEventListener('click', () => {
    const productInfoBlock = document.querySelectorAll('.product-info-block')

    const linkName = link.querySelector('h3')
    productInfoBlock.forEach(block => {
        const blockName = block.querySelector('.product-info-title')
        if (linkName.textContent.trim() === blockName.textContent.trim()) {
            block.classList.add('active')
            block.scrollIntoView({ behavior: 'smooth', block: 'start', offsetTop: -350 });
        }
    })    
  });
});

window.addEventListener('scroll', () => {
    const headerHeight = 150; 
    const productInfoBlocks = document.querySelectorAll('.product-info-block');
  
    const distances = Array.from(productInfoBlocks).map((block, index) => {
      const blockRect = block.getBoundingClientRect();
      const distance = index === 0 ? Math.abs(blockRect.top) : Math.abs(blockRect.top - headerHeight); 
      return {
        block: block,
        distance: distance
      };
    });
  
    distances.sort((a, b) => a.distance - b.distance);
  
    const closestBlock = distances[0].block;
    const closestLinkName = closestBlock.querySelector('.product-info-title');
    lowerHeaderLinks.forEach(link => {
      const linkName = link.querySelector('h3');
      if (linkName.textContent.trim() === closestLinkName.textContent.trim()) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });

    const productInfoContainerRect = productInfoContainer.getBoundingClientRect();
    if (productInfoContainerRect.top <= 100) {
      productInfoHeaderContainer.classList.add('show');
    } else {
      productInfoHeaderContainer.classList.remove('show');
    }
  });
  
  window.addEventListener('scroll', () => {
    if (window.innerWidth >= 1024) {
      const productInfoHeaderContainer = document.querySelector('.product-info-container-header');
      const productInfoHeaderRect = productInfoHeaderContainer.getBoundingClientRect();
      const mainHeader = document.querySelector('sticky-header');
    
      if (productInfoHeaderContainer.classList.contains('show')) {
        mainHeader.style.display = 'none'; 
      } else {
        mainHeader.style.display = 'block';
      }
    }
  });
  
